/* ELLESANTI · tema V3 · pagine del racconto (Il metodo, Lo Spazio), dal prototipo V8. Nessuna libreria. CTRL+G · 30/09/2026.
   Indice «In questa pagina» che resta sotto l'header e segue la sezione che stai leggendo, apertura che entra (e la foto che scorre
   più lenta), mappa che si carica solo al clic (nessun cookie di Google prima), elenco dei rivenditori che si apre.
   Il video dell'apertura e la linea «Come nasce un gioiello» sono in v3-racconto.js; comparse e fisarmoniche in v3-ellesanti.js. */
(function () {
  'use strict';
  var H = document.documentElement;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var ANIM = H.classList.contains('e-anim');
  var mqDesk = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : { matches: true };

  /* ---------------------------------------------------------------- l'indice resta subito sotto l'header */
  function setTop() {
    var hd = $('.e-hd-section'), h = hd ? Math.round(hd.getBoundingClientRect().height) : 0;
    if (h > 0) H.style.setProperty('--e-pgi-top', h + 'px');
  }

  /* ---------------------------------------------------------------- indice: la voce della sezione che stai leggendo
     (resta accesa l'ultima sezione superata, anche mentre leggi una sezione che non è nell'indice) */
  var NAVS = [];
  function initIndice(scope) {
    $$('[data-e-pgi]', scope).forEach(function (nav) {
      if (nav._epg) return;
      nav._epg = true;
      var links = $$('a[href^="#"]', nav), items = [];
      links.forEach(function (a) {
        var id = decodeURIComponent(a.getAttribute('href').slice(1)), el = id && document.getElementById(id);
        if (el) items.push({ a: a, el: el });
        a.addEventListener('click', function (e) {
          var t = id && document.getElementById(id);
          if (!t) return;
          e.preventDefault();
          var off = (nav.getBoundingClientRect().height || 0) + 8;
          var hd = $('.e-hd-section');
          var y = t.getBoundingClientRect().top + window.scrollY - off;
          if (hd && y < window.scrollY) y -= hd.getBoundingClientRect().height;
          window.scrollTo({ top: Math.max(0, Math.round(y)), behavior: ANIM ? 'smooth' : 'auto' });
          if (history.replaceState) { try { history.replaceState(history.state, '', '#' + id); } catch (err) {} }
        });
      });
      nav._items = items;
      NAVS.push(nav);
    });
    spy();
  }
  function spy() {
    var vh = window.innerHeight, mark = vh * 0.38;
    NAVS.forEach(function (nav) {
      if (!document.body.contains(nav)) return;
      var cur = null;
      nav._items.forEach(function (it) {
        var r = it.el.getBoundingClientRect();
        if (r.top <= mark) cur = it;
      });
      nav._items.forEach(function (it) { it.a.classList.toggle('is-on', it === cur); if (it === cur) it.a.setAttribute('aria-current', 'true'); else it.a.removeAttribute('aria-current'); });
      if (cur && cur !== nav._cur) {
        nav._cur = cur;
        var box = cur.a.parentNode;
        if (box && box.scrollWidth > box.clientWidth) {
          var l = cur.a.offsetLeft - 20;
          if (box.scrollTo) box.scrollTo({ left: Math.max(0, l), behavior: ANIM ? 'smooth' : 'auto' }); else box.scrollLeft = l;
        }
      }
    });
  }

  /* ---------------------------------------------------------------- apertura: i testi salgono, la foto scorre più lenta */
  var PXS = [];
  function initApertura(scope) {
    $$('[data-e-pga]', scope).forEach(function (h) {
      if (h._epg) return;
      h._epg = true;
      var img = $('img.e-pga__m', h);
      var go = function () { requestAnimationFrame(function () { requestAnimationFrame(function () { h.classList.add('is-in'); }); }); };
      if (!img || img.complete) go();
      else { img.addEventListener('load', go, { once: true }); img.addEventListener('error', go, { once: true }); setTimeout(go, 1400); }
      var px = $('.e-pga__px', h);
      if (px && ANIM) { h._px = px; PXS.push(h); }
    });
    parallax();
  }
  function parallax() {
    PXS.forEach(function (h) {
      if (!document.body.contains(h)) return;
      if (!mqDesk.matches) { h._px.style.transform = ''; return; }
      var r = h.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      h._px.style.transform = 'translate3d(0,' + (Math.max(0, -r.top) * 0.18).toFixed(1) + 'px,0)';
    });
  }

  /* ---------------------------------------------------------------- mappa: si carica solo quando la chiedi */
  function initMappa(scope) {
    $$('[data-e-map-go]', scope).forEach(function (b) {
      if (b._epg) return;
      b._epg = true;
      b.addEventListener('click', function () {
        var m = b.closest('[data-e-map]');
        if (!m || m.classList.contains('is-on')) return;
        var f = document.createElement('iframe');
        f.src = m.getAttribute('data-src');
        f.title = m.getAttribute('data-title') || '';
        f.loading = 'lazy';
        f.referrerPolicy = 'no-referrer-when-downgrade';
        f.setAttribute('allowfullscreen', '');
        m.appendChild(f);
        m.classList.add('is-on');
      });
    });
  }

  /* ---------------------------------------------------------------- rivenditori: l'elenco completo si apre (desktop) */
  function initRivenditori(scope) {
    $$('[data-e-pgr-more]', scope).forEach(function (b) {
      if (b._epg) return;
      b._epg = true;
      var ol = b.closest('[data-e-pgr-ol]');
      var t0 = b.textContent, t1 = b.getAttribute('data-alt') || t0;
      b.addEventListener('click', function () {
        if (!ol) return;
        var open = !ol.classList.contains('is-open');
        ol.classList.toggle('is-open', open);
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        b.textContent = open ? t1 : t0;
        if (!open) { var r = ol.getBoundingClientRect(); if (r.top < 0) window.scrollTo({ top: window.scrollY + r.top - 160, behavior: ANIM ? 'smooth' : 'auto' }); }
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    setTop();
    initIndice(scope);
    initApertura(scope);
    initMappa(scope);
    initRivenditori(scope);
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; spy(); parallax(); });
  }, { passive: true });
  window.addEventListener('resize', function () { setTop(); spy(); parallax(); });

  window.EllesantiV3 = window.EllesantiV3 || {};
  window.EllesantiV3.hooks = window.EllesantiV3.hooks || [];
  window.EllesantiV3.hooks.push(init);
  window.EllesantiV3.pagine = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
